import React, { Component } from 'react';
import { Parallax } from "react-parallax";

export class HowSpeNeedsWorks extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <section id="how-we-work">
                <Parallax blur={4} bgImage="../img/parallax-bg-5.jpg" strength={500} className="parallax-display">
                    <div className="w-100" style={{ height: 500, width: 100 }} />
                    <div className="parallax-box">How SpeNeeds Works</div>
                </Parallax>
                <div className="p-5 body-lt">
                    <p className="italic">
                        Let's go through a mini walkthrough on how to maximize the SpeNeeds website:
                    </p>
                    <p>
                        Angela, a sixteen year old, has expressed an interest in piano. However, unfortunately, most piano teachers don't have the
                        proper experience to work with Angela's health background, which is that of having symptoms of mid-level learning and behavioral
                        impairments, as well as Autism.
                    </p>
                    <p>
                        Susan, Angela's mother, is thrilled that her daughter has shown the desire to pick up the field of music. Susan wants her daughter
                        to have the best experience and is fairly concered and weary of hiring a piano teacher off Craigslists or simply taking random
                        reccomendations from Angela's high school.
                    </p>
                    <p>
                        And that's where SpeNeeds comes in!
                    </p>
                </div>
                <Parallax blur={4} bgImage="../img/parallax-bg-7.jpg" strength={500} className="parallax-display">
                    <div className="w-100" style={{ height: 500, width: 100 }} />
                    <div className="parallax-box">Together, a Community</div>
                </Parallax>
                <div className="p-5 body-lt">
                    <p>
                        Signing up and creating a member account on the SpeNeeds web application, Angela's mom can find trusted recommendations for piano
                        teachers who have worked with children of similar backgrounds. If Angela's mom has concerns about the piano program, she can check
                        alraedy answered comments or send in an ask herself. After the question has been sent, both the piano teacher and the other students
                        who have worked with the specific teacher will have the ability to answer the submitted question. If Susan likes the program, she can
                        either save the program clicking on the green heart button or she can instantly contact the program coordinators to sign her daughter up.
                        On the other hand, if Susan does not have a specific activity in mind, she can browse different tags and take a look at upcoming events
                        to gain ideas for what is currently being offered in the neighborhood. If she sees something that might be of interest for her daughter,
                        she can similarly favorite those items and they will be booked marked for her under "My Page". Checking back on the "browse" page, Susan
                        also notices that there is a BBQ event this Saturday afternoon. She writes it down in her calendar and will ask Angela if she wants to go
                        during dinner tonight.
                    </p>
                    <p>
                        And just like that, SpeNeeds has directed not only community members to programs and events that will be of interest to them, but also
                        help organizations for children of disabilities properly funnel their information to the right audience.
                    </p>
                    <p>
                        SpeNeeds not only makes families aware of what reliable resources available to them, but also provides reliable and relatable resources.
                        It builds a friendly community for people to share and communicate, maximizing participation for members of all abilities, as well as simplifies
                        the hunt to find appropriate events. Using SpeNeeds is a great way to meet new friends, all while adding to personal growth!
                    </p>
                </div>
                <div className="p-5 body-lt">
                </div>
            </section>
        );
    }
}